// extracted by mini-css-extract-plugin
export default {"language-picker":"GWEUyB1","language-picker__visually-hidden":"EQGIIcV","language-picker__select":"NK29cs1","language-picker__icon":"HdtenoI"};